import React from 'react'
import Button from '../ui-kit/Button'
import { useNavigate } from 'react-router-dom'

function AdminHeader(props) {
  const navigate = useNavigate();
  return (
    <div className='AdminHeader'>
        <div className="title">
            {props.title}
        </div>

        <div className="buttton">
            <Button text={props.textButton} onClick={props.onButtonClick} />
        </div>
    </div>
  )
}

export default AdminHeader